import styled from '@emotion/styled';

export const StyledIconContainer = styled.span`
  margin-top: 20px;
`;
